import { useRef } from 'react';
import { useGridFilter } from 'ag-grid-react';
import { Form } from 'antd';
import { observer } from 'mobx-react-lite';

import 'ag-grid-react';

import { createFilterComponent } from '../create-data-grid-filter';
import { AnyOfFilterForm } from './any-of-filter.form';
import {
  AnyOfFilterModel,
  AnyOfFilterParams,
  createAnyOfFilterModel,
} from './core';

export const AnyOfFilterComponent = createFilterComponent<
  AnyOfFilterModel,
  AnyOfFilterParams
>(
  observer(({ onModelChange, model, filterParams }) => {
    const { filterName, closeWhenChanged, options } = filterParams;
    const shouldClosePopupAfterChange = closeWhenChanged ?? true;
    const hidePopupRef = useRef<(() => void) | undefined>(() => {});
    const hidePopup = () => hidePopupRef.current?.();

    const [form] = Form.useForm();

    useGridFilter({
      // use for disable client-side filtering
      doesFilterPass: () => true,
      afterGuiAttached: (params) => {
        hidePopupRef.current = params?.hidePopup;
      },
    });

    const onSubmit = (value: AnyOfFilterModel['value']) => {
      const model = createAnyOfFilterModel({
        value,
        filterName,
      });

      onModelChange(model);

      if (shouldClosePopupAfterChange) hidePopup();
    };

    const onReset = () => {
      form.resetFields();
      onModelChange(null);

      if (shouldClosePopupAfterChange) hidePopup();
    };

    return (
      <AnyOfFilterForm
        options={options}
        form={form}
        value={model?.value}
        onSubmit={onSubmit}
        onReset={onReset}
      />
    );
  }),
);
